import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    document.body.setAttribute('data-preloader', 'disable');
    const preloader = document.getElementById('preloader');
    preloader?.remove();
  })
  .catch((err) => console.error(err));
